import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { getDefaultAppPath } from '../../utils/navigation';

const HomeRedirect: React.FC = () => {
  const { authState } = useAuth();

  // Si l'utilisateur n'est pas authentifié, le rediriger vers la page de login
  if (!authState.isAuthenticated || !authState.user) {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to={getDefaultAppPath(authState)} replace />;
};

export default HomeRedirect;
